import React from 'react';
import { Truck, Package } from 'lucide-react';
import { Button } from '../../../../../components/ui/Button';

/**
 * The bulk action bar. A seller has a single bulk action here, so there is no
 * "Opciones" menu to hold the rest.
 *
 * Changing the courier is behind Fulfillment Pro, and it is the only thing this
 * bar does, so the page decides whether to mount it at all — along with the
 * selection that feeds it.
 *
 * @param {object} props
 * @param {number} props.selectedCount
 * @param {() => void} props.onChangeCourier
 */
export const AttentionActions = ({ selectedCount, onChangeCourier }) => {
  const hasSelection = selectedCount > 0;

  return (
    <div data-testid="attention-actions" className="min-h-[48px] flex items-center justify-between gap-3">
      {hasSelection ? (
        <div className="flex flex-wrap items-center gap-3">
          <div className="hidden sm:flex items-center gap-2 text-ninja-green font-bold text-sm px-2">
            <Package size={16} />
            <span>
              {selectedCount} {selectedCount === 1 ? 'seleccionado' : 'seleccionados'}
            </span>
          </div>

          <Button variant="primary" size="sm" icon={Truck} onClick={onChangeCourier}>
            Cambiar courier
          </Button>
        </div>
      ) : (
        <span className="text-sm text-text-muted">
          Selecciona envíos para cambiarles el courier a la vez
        </span>
      )}
    </div>
  );
};
